import { compose } from "redux";
const createMiddlewareManager = () => {
  let allMiddlewares = [];
  let allApplyedMiddlewares = [];
  let store;
  const enhancer = (_store) => {
    store = _store;
    return (next) => (action) => {
      return compose(...allApplyedMiddlewares)(next)(action);
    };
  };
  const setStore2 = (_store) => {
    store = _store;
  };
  const addMiddleware2 = (middlewares) => {
    middlewares.forEach((mw) => {
      if (allMiddlewares.includes(mw)) return;
      const applied = mw(store);
      allMiddlewares.push(mw);
      allApplyedMiddlewares.push(applied);
    });
  };
  const removeMiddleware2 = (middleware) => {
    const index = allMiddlewares.findIndex((d) => d === middleware);
    if (index === -1) {
      console.error("Middleware does not exist!", middleware);
      return;
    }
    allMiddlewares = allMiddlewares.filter((_, mdwIndex) => mdwIndex !== index);
    allApplyedMiddlewares = allApplyedMiddlewares.filter(
      (_, mdwIndex) => mdwIndex !== index
    );
  };
  return {
    enhancer,
    addMiddleware: addMiddleware2,
    removeMiddleware: removeMiddleware2,
    setStore: setStore2
  };
};
const middlewareManager = createMiddlewareManager();
const middlewareManagerEnhancer = middlewareManager.enhancer;
const { addMiddleware, removeMiddleware, setStore } = middlewareManager;
export {
  addMiddleware,
  createMiddlewareManager,
  middlewareManagerEnhancer,
  removeMiddleware,
  setStore
};
